import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Change } from "../../../store/async-actions/digitalmarketing/header";
import Tabs from "../../../Component/DigitalMarketing/Tabs";
import { SourceLabel } from "./Utils";
import { Col, Row } from "react-bootstrap";
import { Encryption } from "../../../crypto/aes";
import useSnackbar from "../../../hooks/digitalMarketing/useSnackbar";
import Toast from "../../../Component/DigitalMarketing/Toast";
import Store from "../../../store/Store";
import QrCodeGenerator from "../../../Component/DigitalMarketing/QrCodeGenerator";

function SourceMaster() {
  const { open, message, openSnackBar, type } = useSnackbar();
  const [active, setActive] = useState(1);
  const account = useSelector((state: any) => state.auth);
  const {roleName} = account
  const SourceTab = [{ id: 1, name: "Source Master" }];
  const dispatch = useDispatch();
  useEffect(() => {
    const data: any = {
      first: "Source Master",
    };
    dispatch(Change(data));
  }, [dispatch]);
  // console.log(Store.getState().auth.hospital_code);
  // console.log(Store.getState().auth.hospital_code.trimStart());

  let path = window.location.href.split("/source-master")[0];
  console.log(path,'path')
  const SourceList = {
    facebook: `${path}/${Encryption(
      `Facebook/${Store.getState().auth.hospital_code.trimStart()}`
    )}/${roleName}`,
    instagram: `${path}/${Encryption(
      `Instagram/${Store.getState().auth.hospital_code.trimStart()}`
    )}/${roleName}`,
    google: `${path}/${Encryption(
      `Google/${Store.getState().auth.hospital_code.trimStart()}`
    )}/${roleName}`,
    twitter: `${path}/${Encryption(
      `Twitter/${Store.getState().auth.hospital_code.trimStart()}`
    )}/${roleName}`,
    linkedin: `${path}/${Encryption(
      `Linkedin/${Store.getState().auth.hospital_code.trimStart()}`
    )}/${roleName}`,
    youtube: `${path}/${Encryption(
      `Youtube/${Store.getState().auth.hospital_code.trimStart()}`
    )}/${roleName}`,
  };
  const onCopyText = () => {
    openSnackBar("Copied!");
  };
  return (
    <div>
      {/* <Tabs tablist={SourceTab} active={active} setActive={setActive} /> */}
      <Toast open={open} type={type} message={message} />
      <Row>
        <Col md={9}>
          <div className="cards mt-3 mb-4">
            <Row>
              {SourceLabel.map((item, Index) => (
                <Col md={6} key={Index} className="mt-3">
                  <item.tag
                    {...item}
                    {...SourceList}
                    onCopyText={onCopyText}
                    disab={true}
                  />
                </Col>
              ))}
              <Col md={8} className="mt-3">
                <label>QrCode</label>
                <QrCodeGenerator
                  value={`${path}/${Encryption(
                    `QrCode/${Store.getState().auth.hospital_code.trimStart()}`
                  )}`}
                />
              </Col>
            </Row>
          </div>
        </Col>
      </Row>
    </div>
  );
}

export default SourceMaster;
